import { isBrowser } from 'react-device-detect'
import { FieldValues, RegisterOptions, UseFormRegister } from 'react-hook-form'
import { Input, InputGroup, InputLeftElement, InputProps, InputRightElement, Tooltip } from '@chakra-ui/react'

import { SmallButton } from '~/components/layout/SmallButton'
import { getTokenImage } from '~/helpers'
import { useTranslation } from '~/lib/i18n'
import TokenImage from '../common/TokenImage'

interface Props {
  register: UseFormRegister<FieldValues>
  inputName: string
  registerParams?: RegisterOptions
  onRightButtonClick?: () => void
  rightButtonText?: string
  underlyingSymbol?: string
  isMaxTooltipEnabled?: boolean
}

const CustomInput = ({
  register,
  inputName,
  registerParams,
  onRightButtonClick,
  rightButtonText,
  underlyingSymbol,
  isMaxTooltipEnabled = false,
  ...props
}: Props & InputProps) => {
  const { t } = useTranslation('dashboard')
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.currentTarget.blur()
    }
  }

  return (
    <InputGroup w="full">
      {underlyingSymbol && (
        <InputLeftElement width="auto" my={2} mx={4}>
          <TokenImage name={underlyingSymbol} size="xs" image={getTokenImage(underlyingSymbol)} />
        </InputLeftElement>
      )}
      <Input
        border="none"
        borderRadius={10}
        fontSize={16}
        fontWeight="700"
        p={4}
        h={14}
        paddingRight={28}
        paddingLeft={12}
        bgColor="rgba(255, 255, 255, 0.08)"
        boxShadow="inset 0px 1px 0px rgba(255, 255, 255, 0.04)"
        type="number"
        step="any"
        placeholder={'0'}
        autoComplete="off"
        autoFocus={isBrowser}
        cursor="pointer"
        onKeyDown={handleKeyDown}
        _hover={{ bgColor: 'rgba(255, 255, 255, 0.1)' }}
        _focus={{ border: 'none' }}
        onWheel={(e) => (e.target as HTMLInputElement).blur()}
        onScroll={(e) => (e.target as HTMLInputElement).blur()}
        {...register(inputName, registerParams ?? {})}
        {...props}
      />
      {!!onRightButtonClick && (
        <Tooltip
          isDisabled={!isMaxTooltipEnabled}
          w="280px"
          hasArrow
          placement="top"
          label={t('actionModals.maxWrapped')}
        >
          <InputRightElement width="auto" my={2} mr={4}>
            <SmallButton isDisabled={props.isDisabled} onClick={onRightButtonClick}>
              {rightButtonText}
            </SmallButton>
          </InputRightElement>
        </Tooltip>
      )}
    </InputGroup>
  )
}

export default CustomInput
